import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/index";
import { Card, InputSearch, ToggleButton } from "iuvity-ui-components";
import { SubheaderActions } from "iuvity-ui-components/dist/subheaderactions";
import mainTenantIsotypeLogo from "../../assets/isotipo_iuvity.png";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { useNavigate } from "react-router-dom";
import jp from "jsonpath";

interface ClientListProps {
  data?: any;
  isActions?: boolean;
  title?: string;
  carrousel?: boolean;
  onSelectClientId?: Function;
  apps?: any;
  onSelectTenantId?: Function;
  dataTools?: any;
};

export const ClientList: React.FC<ClientListProps> = ({
  data,
  isActions = false,
  title,
  carrousel = false,
  onSelectClientId,
  apps,
  onSelectTenantId,
  dataTools = [],
}) => {
  const {
    t,
    appState: { dataBrandingObject, infoObjRolesByTenantState: {
      dataRolesByTenantGlobal,
      functionalitiesCodesMap,
    }},
    setAppState
  } = useContext(AppContext);

  const adminTenantsPrivileges = (!!dataRolesByTenantGlobal && !!functionalitiesCodesMap)
    && jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functionalitiesCodesMap['/tenants']}")].permission.privilegeId`);

  const navigate = useNavigate();

  const [dataFilters, setDataFilters] = useState([]);

  const [value, setValue] = useState<string>("");
  const [toggleColumnsActive, setToggleColumnsActive] =
  useState<boolean>(false);

  const updateSearch = (value: string) => {
    setValue(value);
  };

  const orderAlf = (value: boolean) => {
    setToggleColumnsActive(value);

    if (value === false) {
      const sort = data.sort((a: any, b: any) => b.name.localeCompare(a.name))
      setDataFilters(sort);
    } else {
      const sort = data.sort((a: any, b: any) => a.name.localeCompare(b.name))
      setDataFilters(sort);
    }
  };

  useEffect(() => {
    if (data?.length > 0 && value) {
      if (toggleColumnsActive === false) {
        const res = data
          ?.filter((tenant: any) => tenant.name.toLowerCase().includes(value.toLowerCase()))
          ?.sort((a: any, b: any) => b.name.localeCompare(a.name));
        setDataFilters(res);
      } else {
        const res = data
          ?.filter((tenant: any) => tenant.name.toLowerCase().includes(value.toLowerCase()))
          ?.sort((a: any, b: any) => a.name.localeCompare(b.name));
        setDataFilters(res);
      }
    }

    if (value === "") {
      if (toggleColumnsActive === false) {
        const sort = data
          ?.sort((a: any, b: any) => b.name.localeCompare(a.name))
          ?.sort((a: any, b: any) => a?.order - b?.order);
        setDataFilters(sort);
      } else {
        const sort = data?.sort((a: any, b: any) => a.name.localeCompare(b.name))
        setDataFilters(sort);
      }
    }
  }, [value, toggleColumnsActive, data]);

  useEffect(() => {
    setAppState((prev) => ({
      ...prev,
      reloadQuickLinks: false,
    }));
  }, []);
  
  
  return (
    <div className="client-list-main">
      {title && 
        <div className="title">
          {title}
        </div>
      }
      <div className="client-list-container">
        <div className="client-list-content">
          {isActions && 
            <div className="client-list-actions">
              <div>
                <InputSearch
                  id="datatable-inputSearch"
                  placeholder={t("TableHeader.searchPlacehoder")}
                  value={value}
                  setValue={updateSearch}
                />

                <ToggleButton
                  offLabel="A - Z"
                  offIcon="pi pi-sort-amount-up-alt"
                  onLabel="A - Z"
                  onIcon="pi pi-sort-amount-down-alt"
                  checked={toggleColumnsActive}
                  onChange={() => orderAlf(!toggleColumnsActive)}
                  style={{ marginLeft: '0.5rem' }}
                />
              </div>
              <SubheaderActions
                className="m-0 p-0"
                actions={[
                  {
                    id: "111",
                    icon: "iu iu-icon-plus",
                    label: t("Dashboard.createClientBtn"),
                    style: {
                      display: (!!adminTenantsPrivileges && !adminTenantsPrivileges?.includes('CREATE')) ? 'none' : undefined,
                    },
                    onClick: () => navigate(`/tenants/new`),
                  },
                ]}
              />
            </div>
          }
          <div className="client-list-box">
            {apps?.length > 0 && 
              <div className="card-content-app">
                <Card className="card-content" onClick={() => onSelectTenantId && onSelectTenantId()}>
                  <img src={dataBrandingObject?.isotypelogo?.url || mainTenantIsotypeLogo} alt="children-tenants" style={{backgroundColor:'white'}}/>
                  <div className="card-title">
                    {`${t("Dashboard.selectClientApplicationBtn")}: ${apps[0]?.name}`}
                  </div>
                </Card>
              </div>
            }
            {apps?.length > 0 && <div className="card-content-divider"></div>}
            {dataFilters?.length > 0
              ?
                <>
                  <Swiper
                    spaceBetween={50}
                    slidesPerView={5}
                    pagination={{
                      clickable: true,
                    }}
                    modules={[Pagination]}
                    className={`${dataFilters?.length > 5 ? "show-pagination mySwiper" : "mySwiper"}`}
                  >
                    {dataFilters?.map((item: any) => (
                      <SwiperSlide>
                      <Card className="card-content" onClick={() => onSelectClientId && onSelectClientId(item.id, item.name)}>
                          {item.tenantbranding && 
                            <img src={item.tenantbranding.isotypelogo.url} alt="children-tenants" style={{backgroundColor:'white'}}/>
                          }
                          <div className="card-title">
                            {item.name}
                          </div>
                        </Card>
                      </SwiperSlide>
                    ))}   
                  </Swiper>
                </>
              :
              <>
                {dataTools?.length === 0 && <p style={{ height: "139px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>{t("TableActions.emptyMessage")}</p>}
              </>
            }
            
            {dataTools?.length > 0 &&
              <>
                {dataTools?.length > 0 ?
                  <div className="card-content-c">
                    {dataTools?.slice(0,5)?.map((item: any) => (
                      <a 
                        href={item.isexternallink && item.linkto}
                        target={item.isexternallink && '_blank'}
                      >
                        <Card 
                          className="card-content"
                          key={item.id}
                          onClick={() => item.isexternallink === false && navigate(item.linkto)}
                        >
                          {item.iconname && 
                            <div className="card-icon">
                              <i className={item.iconname} />
                            </div>
                          }
                          <div className="card-title">
                            {t(`Quicklinks.${item.labelkey}`)}
                          </div>
                        </Card>
                      </a>
                    ))}
                  </div>
                : 
                  <p style={{ height: "139px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>{t("TableActions.emptyMessage")}</p>
                }
              </>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

                            